import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=62760886&scoped=true&"
import script from "./combination.vue?vue&type=script&lang=js&"
export * from "./combination.vue?vue&type=script&lang=js&"
import style0 from "./combination.vue?vue&type=style&index=0&id=62760886&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62760886",
  null
  
)

export default component.exports